import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import * as CryptoJS from 'crypto-js';
declare var forge: any;


@Injectable()
export class CryptographyService {
  dfgdf: any

  constructor() { }

  encrypt(value: string, key: string = ""): string {
    let aesK = (key == null || key == "") ? CryptoJS.enc.Utf8.parse(this.dfgdf) : CryptoJS.enc.Utf8.parse(key)
    let tmp :any =  CryptoJS.AES.encrypt(value, aesK, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }).toString().trim()
    return tmp
  }

  decrypt(textToDecrypt: string, key: string = "") {
    let aesK = (key == null || key == "") ? CryptoJS.enc.Utf8.parse(this.dfgdf) : CryptoJS.enc.Utf8.parse(key)
    let tmp :any = CryptoJS.AES.decrypt(textToDecrypt, aesK, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8).trim()
    if(tmp != null && tmp == "True"){
      return true
    }
    else if(tmp != null && tmp == "False"){
      return false
    }
    return tmp
  }

  encryptQueryString(para: string, key: string = ""): string {
    let params: any = para.split("&")
    let encrypted = ""
    params.forEach((p: any) => {
      let kv: any = p.split("=")
      encrypted += (encrypted != "") ? "&" : ""
      encrypted += kv[0] + "=" + this.encrypt(kv[1], key)
    });
    return encrypted
  }

  encryptDictValue(obj: object, key: string = ""): object {
    try {
      if (obj == null) {
        return null
      }
      let countArray = 0, countKey = 0, countKeyIn = 0, countKeyEncrypted = 0

      for (var k in obj) {
        countKey++
        if (obj.hasOwnProperty(k)) {
          countKeyIn++
          if (obj[k] != null) {
            if (obj[k].constructor == Object || Array.isArray(obj[k])) {
              countArray++
              obj[k] = this.encryptDictValue(obj[k], key)
            }
            else {
              let objValue = this.tryParseJsonstring(obj[k])
              if(objValue.constructor == Object || Array.isArray(objValue)){
                let tmp: any = this.encryptDictValue(objValue, key)
                obj[k] = tmp
              }
              else if (obj[k] != null && obj[k].toString().trim() != "") {
                countKeyEncrypted++
                try {
                  obj[k] = this.encrypt(obj[k].toString(), key)
                }
                catch (e) { 
                  console.error(e)
                }
              }
            }
          }
        }
      }
    }
    catch (e) {
      console.error(e)
    }
    return obj
  }

  decryptDictValue(obj: any, key: string = ""): any {
    try {
      if (obj == null) {
        return null
      }

      if (Array.isArray(obj)) {
        obj.forEach((o: any) => {
          for (var k in o) {
            if (o.hasOwnProperty(k)) {
              if (o[k] != null) {
                if (o[k].constructor == Object || Array.isArray(o[k])) {
                  let tmp: any = this.decryptDictValue(o[k], key)
                  o[k] = tmp
                }
                else {
                  let objValue = this.tryParseJsonstring(o[k])
                  if(objValue.constructor == Object || Array.isArray(objValue)){
                    let tmp: any = this.decryptDictValue(objValue, key)
                    o[k] = tmp
                  }
                  else if (o[k] != null && o[k].toString().trim() != "" && o[k].constructor != Boolean) {
                    try {
                      let tmp: any
                      if(key != null && key.trim() != ""){
                        tmp = this.decrypt(o[k], key)
                      }
                      else{
                        
                        tmp = this.decrypt(o[k])
                      }
                      o[k] = tmp
                    }
                    catch (e) {
                      try{
                        o[k] = this.decryptDictValue(JSON.parse(o[k]), key)
                      }
                      catch (ex) {
                        console.error(ex)
                      }
                    }
                  }
                }
              }
            }
          }
        });
      }
      else if(obj.constructor == String){
        return this.decrypt(obj.toString(), key)
      }
      else {
        for (var k in obj) {
          if (obj.hasOwnProperty(k)) {
            if (obj[k] != null) {
              if (obj[k].constructor == Object || Array.isArray(obj[k])) {
                let tmp: any = this.decryptDictValue(obj[k], key)
                obj[k] = tmp
              }
              else{
                let objValue = this.tryParseJsonstring(obj[k])
                if(objValue.constructor == Object || Array.isArray(objValue)){
                  let tmp: any = this.decryptDictValue(objValue, key)
                  obj[k] = tmp
                }
                else if (obj[k] != null && obj[k].toString().trim() != "" && obj[k].constructor != Boolean) {
                  try {
                    let tmp: any = this.decrypt(obj[k], key)
                    obj[k] = tmp
                  }
                  catch (e) { 
                    console.error(e)
                  }
                }
              }
            }
          }
        }
      }
    }
    catch (e) {
      console.error(e)
    }

    return obj
  }

  genAesKey() {
    let salt = CryptoJS.lib.WordArray.random(128 / 8);
    let keySize = environment.keySize
    let keyBytes = keySize / 8
    let keyBits = CryptoJS.PBKDF2("lknfsklvjpsg6#$%#lvkdls;jv", salt, { keySize: keySize / 32 });
    let key = keyBits.toString(CryptoJS.enc.Base64)
    if (key.length > keyBytes) {
      let startIndex = (key.length - keyBytes) % 2 == 0 ? (key.length - keyBytes) / 2 : (key.length - keyBytes + 1) / 2
      key = key.substr(startIndex, keyBytes)
    }
    this.dfgdf = key;
    return key;
  }

  rsaEncrypt(publicKey: string, aesKey: string) {
    const key = forge.pki.publicKeyFromPem(publicKey)

    let encryptText = window.btoa(key.encrypt(aesKey));
    return encryptText
  }

  tryParseJsonstring(str: string){
    try {
      return JSON.parse(str);
    } catch (e) {
      return str
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/cryptography.service.ts